const USERBACK_TOKEN = '29714|68362|3qxc6Y2taFG7TaCx8zZNOmttD';
const USERBACK_SRC = 'https://static.userback.io/widget/v1.js';

let scriptEl = null;
let allowed = false;

export function loadUserback(user) {
  allowed = true;
  if (scriptEl) return;

  window.Userback = window.Userback || {};
  window.Userback.access_token = USERBACK_TOKEN;

  // TODO: null-guard / choose the exact fields you want surfaced in tickets
  window.Userback.email = user?.email;
  window.Userback.name  = user?.UserDetails?.nickname || user?.name;
  window.Userback.custom_data = {
    Contact_RecID: user?.UserDetails?.Contact_RecID,
    Company_RecID: user?.UserDetails?.Company_RecID,
    Company_Name:  user?.UserDetails?.Company_Name,
  };

  scriptEl = document.createElement('script');
  scriptEl.async = true;
  scriptEl.src = USERBACK_SRC;
  scriptEl.onload = () => {
    if (!allowed) {
      destroyUserback();
    }
  };
  (document.head || document.body).appendChild(scriptEl);
}

export function destroyUserback() {
  allowed = false;
  try { window.Userback?.destroy?.(); } catch (_) { /* ignore */ }
  if (scriptEl && scriptEl.parentNode) {
    scriptEl.parentNode.removeChild(scriptEl);
  }
  scriptEl = null;
}